import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import * as demoApi from '@/api/demo';
import type { DemoKind } from '@/types';

export const DEMO_KIND_LABELS: Record<DemoKind, string> = {
  lcp: 'Life care planning',
  legal: 'Law firm',
  consulting: 'Consulting'
};

/**
 * Start a demo from /demo. The demo account's active team is now the freshly
 * seeded one, so forget everything cached and enter the app; the shell
 * fetches the session again on mount. Errors are the page's to show inline.
 */
export function useStartDemo() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: demoApi.startDemo,
    onSuccess() {
      qc.clear();
      navigate('/timesheet', { replace: true });
    }
  });
}

/** Reset to the starting data. Confirming first is the caller's job. */
export function useResetDemo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: demoApi.resetDemo,
    async onSuccess() {
      await qc.invalidateQueries();
      toast.success('Demo data reset');
    },
    onError() {
      toast.error('Could not reset the demo.');
    }
  });
}
